export default __webpack_public_path__ + "static/media/Spinning+Studio+West+Island+Gym.6aaea875.jpeg";